import { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Alert, AlertDescription } from "../../components/ui/alert";
import {
  CheckCircle,
  AlertCircle,
  Search,
  Laptop,
  Smartphone,
  Wrench,
} from "lucide-react";
import { GetProtectionPlanDetailsApi } from "../../features/Claims/ClaimsAPI";
import { useParams } from "react-router-dom";
function MagicLinkForm({ onPlanVerified }) {
  const { planId: urlPlanId } = useParams();
  const [planId, setPlanId] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!planId) return;

    setIsChecking(true);
    setError(null);
    setPlan(null);

    try {
      if (!urlPlanId) {
        const response = await GetProtectionPlanDetailsApi({
          planNumber: planId,
          email: null,
        });

        if (response.success) {
          if (response.payload) {
            setPlan(response.payload);
          } else {
            setError(
              "No protection plan found with this ID. Please check your Plan ID."
            );
          }
        } else {
          setError(
            response.error || "Plan verification failed. Please try again."
          );
        }
      }
    } catch (err) {
      console.log("Verification error:", err);
      setError(
        "Failed to connect to verification service. Please try again later."
      );
    } finally {
      setIsChecking(false);
    }
  };

  const handleContinue = () => {
    if (plan) {
      onPlanVerified(plan);
    }
  };

  const getDeviceIcon = (productType) => {
    switch (productType?.toLowerCase()) {
      case "laptop":
        return <Laptop size={12} />;
      case "phone":
        return <Smartphone size={12} />;
      default:
        return <Wrench size={12} />;
    }
  };
  // useEffect(() => {
  //   if (urlPlanId && !plan) {
  //     setPlanId(urlPlanId);
  //   }
  // }, [urlPlanId]);
  // useEffect(() => {
  //   if (planId && urlPlanId && !plan) {
  //     handleSubmit({ preventDefault: () => {} });
  //   }
  // }, [planId]);
  return (
    <div className="max-w-md mx-auto">
      <Card className="!shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="!text-xl">Verify Protection Plan</CardTitle>
          <p className="text-sm text-slate-600">
            Enter your protection plan ID to get started
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Protection Plan ID
              </label>
              <div className="relative">
                <Input
                  type="text"
                  placeholder="CP-2024-XXXXXX"
                  value={planId}
                  onChange={(e) => setPlanId(e.target.value)}
                  className="pl-10"
                />
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
                  size={16}
                />
              </div>
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={!planId || isChecking}
            >
              {isChecking ? "Checking..." : "Verify Plan"}
            </Button>
          </form>

          {error && (
            <Alert variant="destructive">
              <AlertCircle size={16} />
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          {plan && (
            <Alert className="border-success bg-green-50">
              <CheckCircle className="text-success" size={16} />
              <AlertDescription>
                <div className="space-y-2">
                  <p className="font-medium text-success">
                    Plan verified successfully!
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-slate-200">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-6 h-6 bg-xaxathrive-primary rounded flex items-center justify-center">
                        <span className="text-white">
                          {getDeviceIcon(plan.productType)}
                        </span>
                      </div>
                      <span className="font-medium text-slate-900 text-sm">
                        {plan.productName}
                      </span>
                    </div>
                    <div className="text-xs text-slate-600 space-y-1">
                      <p>
                        Plan ID:{" "}
                        <span className="font-mono">{plan.businessPlanID}</span>
                      </p>
                      <p>
                        Coverage:
                        <span className="text-success font-medium ml-1">
                          Active until{" "}
                          {new Date(plan.expirationDate).toLocaleDateString()}
                        </span>
                      </p>
                    </div>
                  </div>
                  <Button
                    onClick={handleContinue}
                    className="w-full mt-3 bg-success hover:bg-green-600"
                  >
                    Continue with Claim
                  </Button>
                </div>
              </AlertDescription>
            </Alert>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default MagicLinkForm;
